/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P4_Footer_NotesInputs */

const en_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription will automatically renew for the same period, but you won’t be charged if you cancel at least 24 hours before the next renewal date.`)
};

const ar_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيتم تجديد اشتراكك تلقائيًا لنفس الفترة، ولكن لن يتم تحصيل رسوم منك إذا قمت بالإلغاء قبل 24 ساعة على الأقل من تاريخ التجديد التالي.`)
};

const de_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Abonnement verlängert sich automatisch um den gleichen Zeitraum, aber es fallen keine Kosten an, wenn Sie mindestens 24 Stunden vor dem nächsten Verlängerungsdatum kündigen.`)
};

const es_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción se renovará automáticamente por el mismo periodo, pero no se te cobrará si la cancelas al menos 24 horas antes de la siguiente fecha de renovación.`)
};

const fr_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement sera automatiquement renouvelé pour la même période, mais vous ne serez pas facturé si vous l’annulez au moins 24 heures avant la date de renouvellement.`)
};

const it_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento si rinnoverà automaticamente per lo stesso periodo, ma non ti verrà addebitato alcun costo se annulli almeno 24 ore prima della successiva data di rinnovo.`)
};

const ja_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションは同じ期間で自動的に更新されますが、次回更新日の24時間前までにキャンセルすれば、課金されることはありません。`)
};

const ko_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독은 같은 기간 동안 자동으로 갱신되지만 다음 갱신일 최소 24시간 전에 취소하면 요금이 부과되지 않아요.`)
};

const pt_br_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura será renovada automaticamente pelo mesmo período, mas a cobrança não será realizada se você efetuar o cancelamento com pelo menos 24 horas de antecedência da próxima data de renovação.`)
};

const ru_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка автоматически продлевается на тот же период, но плата не взимается, если вы отмените её не позднее чем за 24 часа до даты следующего продления.`)
};

const th_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสมัครสมาชิกของคุณจะถูกต่ออายุโดยอัตโนมัติในช่วงเวลาเดียวกัน แต่คุณจะไม่ถูกเรียกเก็บเงินหากยกเลิกอย่างน้อย 24 ชั่วโมงก่อนวันต่ออายุครั้งถัดไป`)
};

const tr_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliğin aynı dönem için otomatik olarak yenilenecektir, ancak bir sonraki yenileme tarihinden en az 24 saat önce iptal edersen herhangi bir ücret alınmaz.`)
};

const zh_cn_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Plus 会员将以相同期限自动续费，但只要在下次续费日的 24 小时前取消，就不会收取费用。`)
};

const zh_tw_subscription_walkthrough_p4_footer_notes = /** @type {(inputs: Subscription_Walkthrough_P4_Footer_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的訂閱將會以相同期限自動續約，但只要在下次續約日的 24 小時前取消，就不會收取費用。`)
};

/**
* | output |
* | --- |
* | "Your subscription will automatically renew for the same period, but you won’t be charged if you cancel at least 24 hours before the next renewal date." |
*
* @param {Subscription_Walkthrough_P4_Footer_NotesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p4_footer_notes = /** @type {((inputs?: Subscription_Walkthrough_P4_Footer_NotesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P4_Footer_NotesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "de") return de_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "es") return es_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "it") return it_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "th") return th_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p4_footer_notes(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p4_footer_notes(inputs)
	return zh_tw_subscription_walkthrough_p4_footer_notes(inputs)
});